import { type ComponentType, type PropsWithChildren, Suspense, createElement } from "react";

export type LazySuspendedExoticComponent<T extends React.ComponentType<any>> = (
  props: React.PropsWithChildren<React.CustomComponentPropsWithRef<T>>
) => React.JSX.Element;

export function SilentSuspense<TProps>(lazyComponent: ComponentType<TProps>) {
  return (props: PropsWithChildren<TProps>) => {
    const { children, ...restProps } = props;
    return <Suspense fallback={null}>{createElement(lazyComponent as any, restProps, children)}</Suspense>;
  };
}
